<template>
  <v-app id="searchTodo">
    <v-main>
     <v-container fluid>
       <v-row no-gutters>
        <v-card class="px-2">
            <v-text-field
            v-model="search"
              label="Search"
              single-line
              hide-details
             >
            </v-text-field>
        
            <v-data-table 
            :items="items" 
            :items-per-page="50" 
            :footer-props="{'items-per-page-options': [50, 100, 200, 300, 500]}"
            :headers="headers"
            :search="search"        
            >
            <template v-slot:item="props">
              <tr>
              <td @click="$router.open('/huov/onHuov/' + props.item.huov_encrid)"><a> {{props.item.huov_code}} </a></td>
              <td><v-chip :color=props.item.hust_kleur>{{props.item.hust_code}}</v-chip></td>
              <td @click="$router.open('/huis/onHuis/' + props.item.huis_encrid)"><a> {{props.item.huis_code}} </a></td>
              <td>{{ $moment(props.item.huov_dt).format("DD-MMM-YYYY HH:mm") }}</td>
              <td>{{props.item.huov_pers}}</td>
              <td>{{ $moment(props.item.huov_van_dat).format("DD-MMM-YYYY ddd") }}</td>
              <td>{{ $moment(props.item.huov_tm_dat).format("DD-MMM-YYYY ddd") }}</td>
              
              <td @click="$router.open('/klnt/onKlnt/' + props.item.klnt_encrid)"><a> {{props.item.klnt_naam}} </a></td>
              <td>{{props.item.klnt_landtaal}} </td>
              <td>{{props.item.klnt_tel1_vcs}} </td>
              <td>{{props.item.inpt_naam}} </td>
              <td>{{props.item.huov_gezel}}</td>
              <td align="right">{{props.item.huov_factuur}}</td>
              </tr>
            </template>
            </v-data-table>
        </v-card>
        </v-row>
     </v-container>
    </v-main>
    <navBar title="Ares - Main menu" :home="true" :accolist="false" type="main"/>
  </v-app>
</template>

<script>
 import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar,
  },
  data() {
    return {
      items: [],
      search: '',
      headers: [
        {text: 'Id', value: 'huov_code'},
        {text: 'Status', value: 'hust_code'},
        {text: 'Accommodation', value: 'huis_code'},
        {text: 'Booking', value: 'huov_dt'},
        {text: 'Persons', value: 'huov_pers'},
        {text: 'Arrival', value: 'huov_van_dat'},
        {text: 'Departure', value: 'huov_tm_dat'},
       
        {text: 'Guest', value: 'klnt_naam'},
        {text: 'Crt / Lang', value: 'klnt_landtaal'},
        {text: 'Telephone', value: 'klnt_tel1_vcs'},
        {text: 'Sales partner', value: 'inpt_naam'},
        {text: 'Travel party', value: 'inpt_gezel'},
        {text: 'Invoice', value: 'huov_factuur'},
      ]
    }  
  },
  mounted() {
      this.results = true;
      this.$axios
        .post("ares/json/ares/huov/searchTodo.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchTodo"
          },
          searchTodo: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.items = res.data.searchTodo;
          }
        })
        .finally(() => {
          this.loading = false;
        });
  }
};

</script> 
